// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3tybO","inner":"Footer_inner__1emVq"};